var dom = {},

	$ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null),

	setupDom = function(){

		dom.document = $(document);
		dom.body = $("body");
		dom.topNav = $(".top-nav");
		dom.menuLink = $(".header__menu-link");
		dom.mainNavContainer = $(".main-nav-container");
		dom.closeLink = dom.mainNavContainer.find(".close-btn");
		dom.parentLink = dom.mainNavContainer.find(".parent > a");

	},

	closeNav = function() {

		dom.mainNavContainer.velocity({
			width: 0
		}, {
			duration: 100,
			complete: function(){
				dom.mainNavContainer.attr("data-expanded", false);
				dom.body.removeClass("main-nav-expanded");
			}					
		});

	},

	addEventHandlers = function(){

		dom.menuLink.on("click", function(e){

			dom.mainNavContainer.velocity({
				width: "100%",
				"max-width": 460
			}, {
				duration: 100,
				complete: function(){
					dom.mainNavContainer.attr("data-expanded", true);
					dom.body.addClass("main-nav-expanded");
				}
			});

			e.preventDefault();

		});

		dom.closeLink.on("click", function(e){

			e.preventDefault();

			closeNav();

		});

		dom.parentLink.on("click", function(e){

			// var $li = $(this).parents("li");

			// if($li.attr("data-expanded") === "true"){

			// 	$li.attr("data-expanded", false);

			// }

			// else {

			// 	$li.attr("data-expanded", true);

			// }

			e.preventDefault();

			window.location = '/websites';

		});

		dom.document.on('click', 'body', function(e) {

			var $el = $(e.target);
			var $nav = $el.closest(".main-nav-container");
			var isMenuOpenLinkClick = $el.closest(".menu").length > 0;
			var isClickInsideMenu = $nav.length > 0;
			var isMenuExpanded = dom.body.hasClass("main-nav-expanded");

			if (isMenuExpanded && !isMenuOpenLinkClick && !isClickInsideMenu) {

				e.preventDefault();

				closeNav();

			}

		});

	},

	init = function(){

		setupDom();

		addEventHandlers();

	};

init();